export enum NotificationChannel {
  Email = 1,
  Sms = 2,
  WebHook = 3,
  FrontApp = 4
}